export default "__VITE_ASSET__DP68szhv__"